import { Layout, theme } from 'antd'

import styles from './index.module.css'

const { Content } = Layout

export interface LayoutContentProps {
  children: React.ReactNode
}

const LayoutContent = ({ children }: LayoutContentProps) => {
  const {
    token: { colorBgContainer, borderRadiusLG },
  } = theme.useToken()

  return (
    <Content
      className={styles.content}
      style={{
        background: colorBgContainer,
        borderRadius: borderRadiusLG,
      }}
    >
      <div className={styles.contentContainer}>{children}</div>
    </Content>
  )
}

export default LayoutContent
